// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_d1-j";
export var fulfillmentFormRail = "_d1-i";
export var headerTitleRow = "_d1-l";
export var orderDetailsWrapper = "_d1-g";
export var orderLinkTrigger = "_d1-2";
export var paymentInformationGrid = "_d1-q";
export var paymentSummaryColumn = "_d1-r";
export var phoneShipmentPickerButton = "_d1-e";
export var phoneShipmentPickerButtonContent = "_d1-f";
export var phoneShipmentPickerButtonWrapper = "_d1-d";
export var phoneShipmentPickerTrigger = "_d1-c";
export var shipmentContainer = "_d1-k";
export var shipmentDetailsMainPane = "_d1-h";
export var shipmentNavigationCard = "_d1-a";
export var shipmentNavigationEdgeTrigger = "_d1-6";
export var shipmentNavigationRail = "_d1-3";
export var shipmentNavigationRailEnter = "_d1-5";
export var shipmentNavigationRailHeader = "_d1-9";
export var shipmentNavigationRailOverlay = "_d1-4";
export var shipmentNavigationScrim = "_d1-7";
export var shipmentSummaryFact = "_d1-n";
export var shipmentSummaryGrid = "_d1-m";
export var shipmentSummaryMetadataRow = "_d1-o";
export var shipmentSummaryTags = "_d1-p";
export var shipmentWorkspace = "_d1-0";
export var shipmentWorkspaceBodyTablet = "_d1-8";
export var shipmentWorkspaceContent = "_d1-b";
export var shipmentWorkspaceHeader = "_d1-1";